import {isMediaFileTypeAsset} from './isMediaFileTypeAsset';

export const assetHasVideo = (
	fileFormatFamily: string[],
	viewNames: string[],
) =>
	isMediaFileTypeAsset(fileFormatFamily) && viewNames.includes('previewH264');
